<template>
    <div id="certbox" style="height: 100%; overflow-y: scroll; padding: 10px;">
      <div v-if="lists && lists.length > 0">
        <el-table
          :data="lists" stripe border
          style="width: 100%">
          <el-table-column
            label="姓名" prop="name">
          </el-table-column>
          <el-table-column
            label="年份" prop="year" width="120" sortable>
          </el-table-column>
          <el-table-column
            prop="learnCount" label="完成课程数" width="180" sortable>
          </el-table-column>
          <el-table-column
            prop="learnHour" label="获得学时" width="180" sortable>
          </el-table-column>
        </el-table>
      </div>
      <h5 class="none_ts" v-if="lists.length == '0'">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
    </div>
</template>

<script>
    export default {
      data () {
        return {
          outputs: [],
          lists: []
        }
      },
      props: ['params'],
      mounted () {
        this.getUserIds(this.params.inputs.filters).then((r) => {
          let userId = r[0].memberUsers[0].userId
          let name = r[0].name
          this.search(userId).then((r) => {
            if (r.data && r.data.length > 0) {
              r.data.forEach((o) => {
                o.name = name
              })
              this.lists = r.data
            } else {
              this.lists = []
            }
          })
        })
      },
      methods: {
        getUserIds (filters) {
          var that = this
          return new Promise(function (resolve, reject) {
            that.$api.post(that.$global.bylApiPath, '/member/members/list', {idCard: filters.idcard}, r => {
              resolve(r.data)
            })
          })
        },
        search (userId) {
          return new Promise((resolve, reject) => {
            this.$api.post(this.$global.courseApiPath, '/course/learn/count/years', {userId: userId}, r => {
              resolve(r)
            })
          })
        }
      }
    }
</script>

<style scoped>
  #certbox .el-table__header {
    border: 0 !important;
  }
  .certbox_list dl {
    width: 300px;
    height: 175px;
    box-shadow: 2px 6px 15px #e6e6e6;
    margin-left: 15px;
    float: left;
    margin-bottom: 35px;
    margin-right: 8px;
    position: relative;
  }
  .certbox_list dl dt img {
    width: 300px;
    height: 140px;
  }
  .certbox_list dl dd h4 {
    height: 40px;
    padding-left: 15px;
    font-weight: normal;
    width: 195px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/byl/CertBox/index.vue